import React, { useEffect } from "react";
import { uri } from "../../help/Api";

import { sto } from "../../Context/InshData";
import useFetchObjectByPost from "../../components/Hooks/useFetchObjectByPost";
import LoadingPage from "../../services/LoadingPage";
import { colors, Container, Grid, makeStyles, Typography } from "@material-ui/core";

import {
  Budget,
  TotalUsers,
  TasksProgress,
  TotalProfit,
  LatestSales,
} from "./components";
import moment from "moment";
import { getLS } from "../../utils/useLS";
import Profile from "./components/Profile";
import { Main } from "../../POS/layouts";
import TotalCard from "../../components/TotalCard";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { GetItemFromOptions } from "../../services/global-services";
import PointSalse from "./PointSale/PointSalse";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    direction: "rtl",
  },
  back1: {
    backgroundColor: colors.red[100],
  },
  back2: {
    backgroundColor: colors.green[100],
  },
  back3: {
    backgroundColor: colors.indigo[100],
  },
}));
const UserDashboard = (props) => {
  const { isZeroDashboard, AutoOptions,found } = props;
  const classes = useStyles();
  //---------------------------------------------------
  const { t } = useTranslation(["forms"]);

  const totalss=AutoOptions?.totals;

  let i={
    cash:Number(totalss?.totRsedStok),
    net:Number(totalss?.totRsedNetW),
    bank:Number(totalss?.totBanks),
    count:Number(AutoOptions?.dailySales[0]?.counts),
    sal:Number(AutoOptions?.dailySales[0]?.total),
    ret:Number(AutoOptions?.dailySales[1]?.total),
  }
  let eradAmount=parseFloat(i.cash+i.net+i.bank)?.toFixed(2);
  let countSal=parseFloat(i.count)?.toFixed(2);
  let safiSales=parseFloat(i.sal-i.ret)?.toFixed(2);
  // let pScr = getLS("premiScr", {});
  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Profile found={found}/>

            <br />
          </Grid>
          <Grid container item spacing={1} lg={12} sm={12} md={12} xs={12}>
            <Grid item lg={4} sm={6} md={4} xs={12}>
              <Budget
                {...{
                  title: t("today-sales"),
                  className: classes.back1,
                  total: isZeroDashboard
                    ? 0
                    : safiSales??0,
                    fetching:false,
                  curr: props?.curr,
                }}
              />
            </Grid>
            <Grid item lg={4} sm={6} md={4} xs={12}>
              <TotalUsers
                {...{
                  className: classes.back2,
                  invCount: isZeroDashboard ? 0 :countSal??0,
                }}
              />
            </Grid>
            <Grid item lg={4} sm={6} md={4} xs={12}>
              <TasksProgress
                {...{
                  className: classes.back3,
                  // value: isZeroDashboard ? 0 : allData?.Revenues,
                  // value: isZeroDashboard ? 0 : erad??0,
                  value: isZeroDashboard ? 0 : eradAmount??0,

                }}
              />
            </Grid>
            {!isZeroDashboard && (
              <Container maxWidth={true} style={{ padding: "4px" }}>
                <Grid container spacing={1} style={{ paddingTop: "10px" }}>
                  <Grid item lg={3} md={3} sm={3} xs={6}>
                    <TotalCard
                      {...{
                        className: null,
                        title: t("fund_balance_for_period"),
                        value: (AutoOptions?.totals?.totRsedStok??0).toFixed(2),

                      }}
                    />
                  </Grid>

                  <Grid item lg={3} md={3} sm={3} xs={6}>
                    <TotalCard
                      {...{
                        className: null,
                        title: t("network_balance"),
                        value: (AutoOptions?.totals?.totRsedNetW??0).toFixed(2),

                      }}
                    />
                  </Grid>
                  <Grid item lg={3} md={3} sm={3} xs={6}>
                    <TotalCard
                      {...{
                        className: null,
                        title: t("bank_balance"),
                        value: Number(AutoOptions?.totals?.totBanks??0).toFixed(2),

                      }}
                    />
                  </Grid>
                  <Grid item lg={3} md={3} sm={3} xs={6}>
                    <TotalCard
                      {...{
                        className: null,
                        title: t("foward_balance"),
                        value: (AutoOptions?.totals?.totAgels??0).toFixed(2),

                      }}
                    />
                  </Grid>
                </Grid>
              </Container>
            )}

            <Grid item lg={12} md={12} xs={12} sm={12}></Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
export const POSDashboardCon = (props) => {
  const {found}=props;
  const defaultAutos = {
    dailySales: [],
  };

  const tb = {
    wait: true,
    // costcenters: true,
    defaultOmla: true,
    // DailySales: true,
    DailySales: sto?.notShowSales==true?false:true,
    // Users: true,
    stor: sto,
    parms: {
      branch: sto.branchi,
      iempid: sto.empi,
      db_name: sto.db_name,
    },
  };
  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "Rept",
    tb
  );

  if (fetchAll || !AutoOptions?.defaultOmla) return <LoadingPage />;

  return (
    <Main>
      {/* <UserDashboard */}
      <PointSalse
        {...{
          curr: AutoOptions?.defaultOmla?.symbol,
          isZeroDashboard: sto?.pos_dashboard_zero ?? false,
          AutoOptions: AutoOptions?.dailySales ? AutoOptions : defaultAutos,
          found:found,
        }}
      />
      <br />
    </Main>
  );
};

export default POSDashboardCon;
